module.exports = __webpack_public_path__ + "img/display4.9e46da3b.jpg";